'use client';
import { useEntropyBrowser } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { isNavSearchExcludedMode } from '#pplx/frontend/apps/ask/queries/navigational-queries/shouldRunNavigationalSearch.js';
import { isCometBrowser } from '#pplx/frontend/comet/client/utils.js';
import { useGetStreamTimer } from '#pplx/frontend/stream/stream.js';
import { useCallback } from 'react';
export const useInjectSearchResults = () => {
    const isComet = isCometBrowser();
    const entropyBrowser = useEntropyBrowser();
    const getStreamTimer = useGetStreamTimer();
    const shouldTrigger = useCallback((params) => {
        const isFollowup = !!params.last_backend_uuid;
        const isWebSearch = params.sources?.some((source) => source === 'web') ?? true;
        return (isWebSearch &&
            isComet &&
            !isFollowup &&
            !import.meta.env.VITE_IS_SIDECAR_BUILD &&
            !isNavSearchExcludedMode(params.model_preference) &&
            !params.override_no_search);
    }, [isComet]);
    return useCallback((query, params, streamId) => {
        if (!query || !shouldTrigger(params))
            return;
        const timer = getStreamTimer(streamId);
        if (!timer)
            return;
        entropyBrowser.injectSearchResults(query, streamId, {});
    }, [entropyBrowser, shouldTrigger, getStreamTimer]);
};
//# sourceMappingURL=useInjectSearchResults.js.map